import {Redirect, Route, Switch, useParams} from "react-router-dom";
import React, {useEffect, useMemo} from "react";
import Container from "react-bootstrap/Container";
import NavitemGroup from "./NavitemGroup";
import Navitem from "./Navitem";
import Navbar from "./Navbar";
import {useTranslation} from "react-i18next";
import Error404 from "../errors/Error404";
import NoMenuRoute from "./NoMenuRoute";

export default function Navigation(props) {

  const navItemToRoute = ({text, icon, ...routeProps}) => <Route {...routeProps}/>
  const isLeafComponent = ( component ) => ([Navitem, NoMenuRoute].includes(component.type))
  const routes = useMemo(() => {
    function getNavItems(children) {
      return React.Children.toArray(children).map(child => {
        if (child.type === NavitemGroup) return getNavItems(child.props.children)
        if ( isLeafComponent(child)) return child
      })
    }

    return getNavItems(props.children).flat().map((child, i) => {
      return navItemToRoute({...child.props, key: i})
    })
  }, [props.children]);

  return <>
    <Navbar>
      {props.children}
    </Navbar>
    <div className="page-container" id="content-panel">
      <Container>
        <Switch>
          {routes}
          <Route path="/:lang">
            <LangRootRedirect rootUrl={props.rootUrl}/>
          </Route>
          {props.rootUrl && <Route exact path="/" render={() => <Redirect to={props.rootUrl}/>}/>}
        </Switch>
      </Container>
    </div>
  </>
}

function LangRootRedirect(props) {
  const {i18n} = useTranslation();
  const {lang} = useParams()
  const supportedLngs = ["fr", "en"]
  const isLangSupported = supportedLngs.includes(lang.toLowerCase())

  useEffect(() => {
    isLangSupported && i18n.changeLanguage(lang)
  })

  if (isLangSupported) {
    return <Redirect to={props.rootUrl || '/'}/>
  } else {
    return <Error404/>
  }
}
